import React from 'react';
import { Transition } from 'react-spring/renderprops.cjs';

/* eslint-disable react/prop-types */

var BaseAnimation = function BaseAnimation(_ref) {
  var _ref$keys = _ref.keys,
      keys = _ref$keys === void 0 ? undefined : _ref$keys,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 100 : _ref$duration,
      _ref$enter = _ref.enter,
      enter = _ref$enter === void 0 ? {} : _ref$enter,
      _ref$from = _ref.from,
      from = _ref$from === void 0 ? {} : _ref$from,
      _ref$leave = _ref.leave,
      leave = _ref$leave === void 0 ? {} : _ref$leave,
      _ref$onRest = _ref.onRest,
      onRest = _ref$onRest === void 0 ? function () {
    return null;
  } : _ref$onRest,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(Transition, {
    config: {
      duration: duration
    },
    enter: enter,
    from: from,
    items: items,
    keys: keys,
    leave: leave,
    onRest: onRest
  }, children);
};

export default BaseAnimation;
//# sourceMappingURL=BaseAnimation.js.map
